/**
 * Confirmation overlay shown before removing a registered FCM device.
 */

import React from 'react';

interface RemoveDeviceConfirmModalProps {
  isCurrentDevice: boolean;
  isRemoving: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export const RemoveDeviceConfirmModal: React.FC<RemoveDeviceConfirmModalProps> = ({
  isCurrentDevice,
  isRemoving,
  onCancel,
  onConfirm,
}) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-scrim/50">
      <div className="bg-surface rounded-lg shadow-xl p-6 max-w-sm mx-4">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-full bg-danger-soft flex items-center justify-center">
            <i className="fa-solid fa-trash-can text-danger"></i>
          </div>
          <div>
            <h3 className="font-semibold text-ink">Remove Device?</h3>
            <p className="text-sm text-ink-muted">
              This device will stop receiving push notifications.
            </p>
          </div>
        </div>
        {isCurrentDevice && (
          <div className="mb-4 p-3 bg-warning-subtle border border-warning-border rounded-md">
            <p className="text-sm text-warning-strong">
              <i className="fa-solid fa-triangle-exclamation mr-1"></i>
              This is your current device. You can re-register by refreshing the page.
            </p>
          </div>
        )}
        <div className="flex justify-end gap-3">
          <button
            onClick={onCancel}
            disabled={isRemoving}
            className="px-4 py-2 text-ink-body hover:bg-surface-hover rounded-lg transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={isRemoving}
            className="px-4 py-2 bg-danger text-ink-inverse rounded-lg hover:bg-danger-deep transition-colors disabled:opacity-50 flex items-center gap-2"
          >
            {isRemoving ? (
              <>
                <i className="fa-solid fa-circle-notch fa-spin"></i>
                Removing...
              </>
            ) : (
              'Remove'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};
